<template>
    <a :href="url" :class="activeClass" @click.prevent="select">
        <slot name="button-inner">
            {{ name }}
        </slot>

        <teleport v-if="isActive" :to="TabState.teleport">
            <slot />
        </teleport>
    </a>
</template>

<script type="text/babel">
import { empty, optional } from '@makeabledk/vue-ui/support/helpers'
import HasSubscriptions from '@makeabledk/vue-ui/mixins/has-subscriptions'

export default {
    mixins: [HasSubscriptions],

    inject: ['TabState'],

    props: ['name', 'slug', 'default', 'activeClasses'],

    data() {
        return {
            active: null,
        }
    },

    computed: {
        activeClass() {
            return this.isActive ? this.TabState.activeTabClass : null
        },

        id() {
            return empty(this.default) || this.default === false
                ? optional(this.slug, () => this.name.toLowerCase().replace(/ /g, '-'))
                : ''
        },

        isActive() {
            return this.id === this.active
        },

        url() {
            return '#' + this.id
        },
    },

    created() {
        this.subscribe(this.TabState.active, (active) => {
            this.active = active.id
            this.TabState.tabs[this.id] = this.isActive
        })
    },

    beforeUnmount() {
        delete this.TabState.tabs[this.id]
    },

    methods: {
        select() {
            this.TabState.active.next({
                id: this.id,
                url: this.url,
            })
        },
    },
}
</script>
